(function () {
  var started = false;
  var granted = false;
  window.dataLayer = window.dataLayer || [];
  function queue() {
    window.dataLayer.push(arguments);
  }
  function consent(command, value) {
    queue('consent', command, {
      analytics_storage: value,
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value
    });
  }
  consent('default', 'denied');
  function clearTrackingStorage() {
    var domains = window.location.hostname.split('.');
    document.cookie.split(';').forEach(function (cookie) {
      var name = cookie.split('=')[0].trim();
      if (!/^(_ga|_gcl|_fbp|_fbc|_uet)/.test(name)) return;
      var expiry = name + '=; Max-Age=0; Path=/; Secure; SameSite=Lax';
      document.cookie = expiry;
      for (var i = 0; i < domains.length - 1; i++) {
        document.cookie = expiry + '; Domain=' + domains.slice(i).join('.');
      }
    });
    try {
      ['_uetvid', '_uetvid_exp', '_uetsid', '_uetsid_exp', '_gcl_ls',
        'lastExternalReferrer', 'lastExternalReferrerTime'].forEach(function (key) {
        window.localStorage.removeItem(key);
      });
    } catch (error) {}
  }
  function sync() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    var choice = privacy.currentVisitorConsent();
    var allowed = choice.analytics === 'yes' && choice.marketing === 'yes' &&
      privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
    var withdrawn = granted && !allowed;
    if (allowed !== granted) {
      granted = allowed;
      consent('update', allowed ? 'granted' : 'denied');
    }
    if (withdrawn) {
      clearTrackingStorage();
      window.setTimeout(function () { window.location.reload(); }, 0);
      return;
    }
    if (!allowed || started) return;
    started = true;
    ['GTM-56G6GBV5', 'GTM-NSR7W2ZG'].forEach(function (id) {
      window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=' + id;
      document.head.appendChild(script);
    });
  }
  function ready() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
      if (!error) sync();
    });
  }
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-consent-settings]');
    var cmp = window.Pandectes;
    if (link && cmp && cmp.fn && typeof cmp.fn.showBanner === 'function') {
      event.preventDefault();
      cmp.fn.showBanner();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
}());
